<div class="matero-sidebar-main scrollbar-none">
  <app-sidemenu></app-sidemenu>
  <ng-content></ng-content>
</div>
